import { parseEther, formatEther } from 'viem';
import { addAndBurnLiquidity } from './quickswap';

export const LIQUIDITY_THRESHOLD = parseEther("100000"); // 100k MATIC threshold

export const checkAndBurnLiquidity = async (
  walletClient: any,
  tokenAddress: string,
  marketCap: bigint
) => {
  if (marketCap >= LIQUIDITY_THRESHOLD) {
    console.log(`Market cap threshold reached: ${formatEther(marketCap)} MATIC`);
    
    // Calculate liquidity amounts (17k worth of liquidity)
    const liquidityAmount = parseEther("17000");
    const tokenAmount = (liquidityAmount * BigInt(2)); // Equivalent token amount
    
    try {
      const hash = await addAndBurnLiquidity(
        walletClient,
        tokenAddress as `0x${string}`,
        tokenAmount,
        liquidityAmount
      );
      
      console.log(`Liquidity burned successfully. Transaction: ${hash}`);
      return hash;
    } catch (error) {
      console.error("Error burning liquidity:", error);
      throw error;
    }
  }
  return null;
};